import { lazy } from 'react';

export const GoogleAwaitPageLazy = lazy(() => import('./google-await-page'));
